module.exports = __webpack_public_path__ + "static/media/medical-sci.b8439edd.jpg";